export default __webpack_public_path__ + "static/media/Banner - AirStrapz - White.5d36e415.jpg";